'use client';

import { getAppConfig } from '@services/config';
import { logger } from '@services/loggers';

import { getServerSession } from '@actions/get-session';

import { TagEventType, TagParamClick, TagParamDataLayer } from '@app-types/tracking';

import { envParams } from '@constants/tags';

import { tagsStore } from '@stores/tags';

declare global {
    interface Window {
        tc_events_2: Record<string, unknown>;
        tc_vars: Record<string, unknown>;
        tC: Record<string, unknown>;
    }
}

let tagCoConnectAttempt = 0;

const appConfig = getAppConfig();

export default function useTracking() {
    const sendTag = async (
        params: TagParamDataLayer | TagParamClick,
        eventType: TagEventType,
        // extra?: any
    ) => {
        if (typeof window === 'undefined') return;
        const userSpecificTag: Record<string, unknown> = {};
        const session = await getServerSession();
        const user = session?.user;
        if (user) {
            userSpecificTag.connexion = !!user.connected;
            userSpecificTag.structureClient = {
                id_personne: user.sub,
                user_type: user.user_type,
                accessToken: user.accessToken,
            };
        }
        const tagParam = {
            ...envParams,
            ...userSpecificTag,
            ...params,
            pageVariante: { ...envParams.pageVariante, ...params.pageVariante },
        };

        if (typeof window.tc_events_2 === 'function') {
            if (appConfig.tracking?.debug) {
                logger.log('tagParam: ', tagParam);
            }
            window.tc_vars = {
                ...window.tc_vars,
                ...tagParam,
            };
            (window.tc_events_2 as (context: unknown, eventType: TagEventType, vars: Record<string, unknown>) => void)(
                undefined,
                eventType,
                window.tc_vars,
            );
        } else {
            if (tagCoConnectAttempt > 20) return;
            setTimeout(() => {
                tagCoConnectAttempt++;
                sendTag(params, eventType);
            }, 1500);
        }
    };

    const { currentPageTags, setCurrentPageTags } = tagsStore((state) => state);

    return { sendTag, currentPageTags, setCurrentPageTags };
}
